import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';

import { RecaptchaService } from './services/recaptcha.service';

/**
 * Root shell for the long-form prequal app. Loads the reCAPTCHA script on init
 * so tokens are ready when the customer reaches submit.
 */
@Component({
  selector: 'capq-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly recaptchaService = inject(RecaptchaService);

  ngOnInit(): void {
    this.recaptchaService.loadRecaptchaScript();
  }
}
